export default __webpack_public_path__ + "static/media/icon-footer-facebook.e6b6bd42.svg";